import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class IndexAndViewer extends Component {
  static propTypes = {
    activeLink: PropTypes.number,
    content: PropTypes.object.isRequired,
    list: PropTypes.object.isRequired,
    handleSelect: PropTypes.func.isRequired,
    title: PropTypes.string,
  };

  static defaultProps = {
    activeLink: null,
    title: '',
  };

  constructor() {
    super();
    this.toggleDropDown = this.toggleDropDown.bind(this);
  }

  state = {
    showDropDown: false,
    selectedOption: 'Select',
  };

  setSelectedOption = name => {
    this.setState({ selectedOption: name });
  };

  toggleDropDown = () => {
    this.setState({ showDropDown: !this.state.showDropDown });
  };

  handleClick = (item, key) => evt => {
    const { handleSelect } = this.props;
    handleSelect(item, key, evt);
    this.setSelectedOption(item.name || item.companyName);
    this.toggleDropDown();
  };

  renderItems = (item, key) => {
    const { activeLink } = this.props;
    return item ? (
      <button
        key={key}
        type="button"
        tabIndex={0}
        className={`dropdown-item ${activeLink === key ? 'active' : ''}`}
        onClick={this.handleClick(item, key)}
      >
        {item.name || item.companyName}
      </button>
    ) : null;
  };

  render() {
    const { content, list, title } = this.props;
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-12">
              <div className="card-border">
                <div className="card-header">
                  <div className="card-header-title">{title ? { title } : 'Select Dataset'}</div>
                </div>
                <div className="card-block">
                  <div className={`dropdown ${this.state.showDropDown ? 'show' : ''}`}>
                    <button
                      className="btn btn-secondary dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded={this.state.showDropDown}
                      onClick={this.toggleDropDown}
                    >
                      {this.state.selectedOption}
                    </button>
                    <div
                      className={`dropdown-menu ${this.state.showDropDown ? 'show' : ''}`}
                      aria-labelledby="dropdownMenuButton"
                      style={{ display: this.state.showDropDown ? 'block' : 'none' }}
                    >
                      {list.map(this.renderItems)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card-border">
                <div className="card-block">{content}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
